import { render, staticRenderFns } from "./bannerEdit.vue?vue&type=template&id=090b5069&scoped=true"
import script from "./bannerEdit.vue?vue&type=script&lang=js"
export * from "./bannerEdit.vue?vue&type=script&lang=js"
import style0 from "./bannerEdit.vue?vue&type=style&index=0&id=090b5069&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090b5069",
  null
  
)

export default component.exports